import React from "react";

export default function NoQuestions() {
  return <div>Your questions will appear here...</div>;
}
